enum COMPARE_TO {
    COMPSET_AVG = 'compset',
    LAST_YEAR = 'lastYear'
}
export default COMPARE_TO;
